import { MouseEvent, useCallback } from 'react';
import { Edge } from 'reactflow';
import { CanvasElementState } from '@components/MainStage/canvasStates';
import { getHoverState } from '@components/MainStage/hover.store';

const useEdgeHoverHandlers = () => {
  const onEdgeMouseEnter = useCallback((_: MouseEvent, edge: Edge) => {
    if (edge.data?.canvas?.state === CanvasElementState.Disabled) return;

    getHoverState().setHoveredEdge({
      id: edge.id,
      source: edge.source,
      target: edge.target,
    });
  }, []);

  const onEdgeMouseLeave = useCallback(() => {
    getHoverState().setHoveredEdge(null);
  }, []);

  return { onEdgeMouseEnter, onEdgeMouseLeave };
};

export default useEdgeHoverHandlers;
